import React from "react";

export function useBooleanState(initialValue = false) {
  const [value, setValue] = React.useState(initialValue);
  const setTrue = React.useCallback(() => setValue(true), []);
  const setFalse = React.useCallback(() => setValue(false), []);
  const toggle = value ? setFalse : setTrue;
  return [value, setTrue, setFalse, toggle] as const;
}
